import { Dialog , Toast } from 'vant'; 
import qs from 'qs'
import axios from "axios";
import store from "@/store/index";
import router from '@/router'//引入路由
import statistics from "../statistics";



// create an axios instance
const service = axios.create({
  baseURL: '/hd-weixin/api/', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
});

// post请求的时候，我们需要加上一个请求头，所以可以在这里进行一个默认的设置
// 即设置post的请求头为application/x-www-form-urlencoded;charset=UTF-8
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

const pending = [];
const cancelToken = axios.CancelToken;

// 设置统计

// const setPageStatistics = ({ config } , curRoute) => {
//     statistics(config , curRoute);
// };

/**
 * 处理重复请求
 * @param  {} {config}={} AxiosRequestConfig
 */
const addPending = ({ config }) => {
  const url =
    config.url + "&" + config.method + "&" + qs.stringify(config.params);
  config.cancelToken = new cancelToken(cancel => {
    if (!pending.some(item => item.url === url)) {
      pending.push({
        url,
        cancel
      });
    }
  });
};
const removePending = ({ config }) => {
  const url =
    config.url + "&" + config.method + "&" + qs.stringify(config.params);
  pending.forEach((item, index) => {
    if (item.url === url) {
      item.cancel("取消重复请求:" + config.url);
      pending.splice(index, 1);
    }
  });
};

/**
 * 请求头预处理
 * @param  {} {config} AxiosRequestConfig
 */
const requestHeaders = ({ config }) => {
  //1.时间戳
  const timestamp = new Date().getTime();
  config.headers.timestamp = timestamp;
  //2. post qs
  // const method_handler = {
  //   'post': qs.stringify(config.data)
  // }
  
  // config.data = method_handler[config.method];
  
  if(config.method == "post" || config.url.indexOf('logins/link') != -1){
    store.commit('comp/POST_LOADING',true);
  };
  // if(config.method == 'post' && config.headers['Content-Type'].indexOf('multipart') == -1 ){ //去掉post请求地址上自带 上传不用管
  //   config.data = qs.stringify({...config.params});
  //   config.params = {};
  // };
  // 登录流程控制中，根据本地是否存在token判断用户的登录情况
  // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
  // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
  // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
  // //3.token
  // const token = sessionStorage.getItem("token");
  // if (token) {
  //   config.headers.token = token;
  // }
};

/**
 * 请求拦截器
 */

service.interceptors.request.use(
  config => {
    // console.log('请求地址---',config.url);
    // console.log('当前路由---', router)
    //setPageStatistics( {config} ,  router.currentRoute);
    // statistics(config , router.currentRoute);
    requestHeaders({config});
    removePending({ config });
    addPending({ config });
    return config;
  },
  error => {
    if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
      console.log(error);
      Toast("网络超时，请稍后再试！");
      return Promise.reject(error);          // reject这个错误信息
    }
    return Promise.reject(error);
  }
);


/**
 * 请求结束&&loading=false
 * @param  {} {config}={} AxiosRequestConfig
 * @param  {} {config}={} response body
 */
const requestEnd = ({ config, data } = {}) => {
  if(config.method == "post" || config.url.indexOf('logins/link') != -1){
    Toast.clear();
    store.commit('comp/POST_LOADING',false);
  };
  //移除队列
  removePending({ config });
};

/**
 * @param  {} {status HTTP状态码
 * @param  {} data 响应体
 * @param  {} config}={} AxiosRequestConfig
 */
const responseResolve = ({ status, data, config } = {}) => {
  const { success, message , errCode } = data;
  if (status === 200) {
    if(success){
      // post请求成功以后 如果全局的loading存在 立马清除Toast 这样loading去除
      // 为什么不在app.vue里clear 有执行先后顺序问题 会和 error冲突
      
      //if(store.getters['comp/getPostLoading']){
        Toast.clear();
        store.commit('comp/POST_LOADING',false);
      //};
      return Promise.resolve(data);
    }else{

      if(errCode == '15007' || errCode == '15006'){
        if(errCode != '15006'){
          Toast(message || "登录超时，请重新登录！");
        }
        
        let url = router.history.current.fullPath;
        
        if(!/account/.test(url)){ //防止已经跳转到 account 了 还要继续push （多个接口返回登录超时）;
          
          router.replace({name:'account',query:{ url :url}});
        };
       // window.location.href = process.env.VUE_APP_AUTH_URL;
      }else if(errCode == '_EMPTY' || errCode == 'UNIONID_NOT_EXIST'){
        Dialog.alert({
          title: '提醒',
          message: '你未授权，请刷新页面重新授权！'
        }).then(() => {
          // on close
        });        
      }else if(errCode == 'USER_REPEAT_UNIONID_ERROR'){
        Toast("一个账号不能绑定多个微信号");
      }else if(errCode == 'UNIONID_REPEAT_USER_ERROR'){
        Toast("该微信号不能绑定多个账号");
      }else if(errCode == '15101'){
        router.push({path:'/account/certification', query:{
          status:""
        }});
      }else if(errCode == '15102'){
        router.push({path:'/account/certification', query:{
          status:1
        }});

      }else if(errCode == '15103'){
        router.push({path:'/account/certification', query:{
          status:3
        }});
      }else {
        Toast(message || "系统异常，请稍后再试！");
      }
      
      return Promise.reject(data);
    }
  } else {
    Toast(message || "操作失败！");
    //store.commit("setLoading", false);
    return Promise.reject(data);
  }
};

// 响应拦截器
service.interceptors.response.use(
  // 请求成功
  res => {
    const { status, data, config } = res;
    requestEnd({ config, data });
    return responseResolve({ status, data, config });
  },
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      console.log("err" + error); // for debug
      const status = response && response.status;
      let message = "";

      switch (status) {
        case 400:
          message = "参数异常";
          break;
        case 404:
          message = "请求资源未找到";
          break;
        case 401:
          message = "无权限";
          setTimeout(() => {
            //处理登录失效，例如跳转到登陆页
          }, 1000);
          break;
        case 500:
          message = "服务器异常";
          break;
        // 其他错误...
        default:
          message = "服务器繁忙" + '(' +  status + ')';
          break;
      }
      Toast({
        message: message,
        duration: 1000,
        forbidClick: true
      });
      return Promise.reject(error);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      //store.commit('changeNetwork', false);
    }
  }
);

// service.all = function(args,args2){
  
// }
/*
5.4 封装图片上传
// src/api/index.js
export const uploadFile = formData => {
  const res = service.request({
    method: 'post',
    url: '/upload',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return res
}
调用

async uploadFile (e) {
  const file = document.getElementById('file').files[0]
  const formdata = new FormData()
  formdata.append('file', file)
  await uploadFile(formdata)
}

5.5 请求 显示 Loading 效果
let loading = null
service.interceptors.request.use(config => {
  // 在请求先展示加载框
  loading = Loading.service({
    text: '正在加载中......'
  })
  // 省略其它代码 ······
  return config
}, (error) => {
  return Promise.reject(error)
})
service.interceptors.response.use(response => {
  // 请求响应后关闭加载框
  if (loading) {
    loading.close()
  }
 // 省略其它代码 ······
}, error => {
  // 请求响应后关闭加载框
  if (loading) {
    loading.close()
  }
  // 省略其它代码 ······
  return Promise.reject(error)
})

*/
// console.log(service.all, 'alll');

/*
  DB.request
  DB.get
  DB.post

  DB.all
*/

export const uploadFile = config => {
  console.log(config);
  console.log(config.params);
  
  const res = service.request({
    method: 'post',
    url: config.url,
    data: config.params,
    headers: { "Content-Type": "multipart/form-data" }
  })
  return res
}

export default service;
